import camelize from 'camelize'
import PropTypes from 'prop-types'

import { translate } from '@/utils/translations'

const Package = ({ asset, isHalf }) => {
  const { author, bookCoverUrl, isbn, title } = camelize(asset)
  return (
    <li className={`package-asset-${isHalf ? 'half' : 'third'} pb-3`}>
      <img
        alt=''
        className='product-cover'
        src={bookCoverUrl}
      />
      <div className='package-info-wrap d-flex flex-column'>
        <span className='u-weight--bold line-height-3'>{title}</span>
        <p className='remove-ios-formatting'>
          {`${translate('common.isbn')}: ${isbn}`}
        </p>
        <p>
          {author}
        </p>
      </div>
    </li>
  )
}

export default Package

Package.propTypes = {
  asset: PropTypes.object.isRequired,
  isHalf: PropTypes.bool
}
